export default __webpack_public_path__ + "static/media/ass_sec_gen_2025.f3bf06f4.jpg";